module.exports = __webpack_public_path__ + "img/banner-2-tablet.d349113.webp";